import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../../css/Navbar.scss';

import { PiListBold } from "react-icons/pi";
import { MenuItems } from './MenuItems';
import { isFaculty, isStudent } from '../../helpers/permissions';

export default function Navbar({ user }) {
    const dropdownRef = useRef(null);
    const mobileDropdownRef = useRef(null);
    const faDropdownRef = useRef(null);
    const p91DropdownRef = useRef(null);
    const [dropdown, setDropdown] = useState(false);
    const [mobileDropdown, setMobileDropdown] = useState(false);
    const [faDropdown, setFADropdown] = useState(false); 
    const [p91Dropdown, setP91Dropdown] = useState(false); 

    const mobileDisplayedItem = MenuItems[user ? 1 : 0]

    const handleClickOutside = (e) => {
        //if (dropdown && dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        //    setDropdown(false);
        //}
        if (mobileDropdown && mobileDropdownRef.current && !mobileDropdownRef.current.contains(e.target)) {
            setMobileDropdown(false);
        }
        //if (faDropdown && faDropdownRef.current && !faDropdownRef.current.contains(e.target)) {
        //    setFADropdown(false);
        //}
        //if (p91Dropdown && p91DropdownRef.current && !p91DropdownRef.current.contains(e.target)) {
        //    setP91Dropdown(false);
        //}
    };
    
    const isLoggedIn = (e) => {
        return ((user ? true : false))
    }

    const isAdmin = (e) => {
        return ((user?.permissions & 2) === 2);
    }

    const isAdvisor = (e) => {
        return ((user?.permissions & 1) === 1);
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdown, mobileDropdown, faDropdown, p91Dropdown]);

    return (
        <>
            <nav className='navbar'>
                <Link to='/' className='navbar-title' >
                    SAACS
                </Link>
                {/*<ul className='nav-menu desktop-only'>
                    <li className='nav-item'>
                        <Link to='/' className='nav-links' >
                            Home
                        </Link>
                    </li>
                    {isLoggedIn() && !isAdvisor() && ( //Student ForceAdd
                        <li
                            className='nav-item'
                            onClick={() => setFADropdown(!faDropdown)}
                            ref={faDropdownRef}
                        >
                            <div className='nav-links'>
                                Force Add <i className='fas fa-caret-down'/>
                            </div>
                            {faDropdown &&
                            <ul className='nav-fa-dropdown-listB desktop-only'>
                                <fieldset>
                                    <legend style={{color: "white"}}>Undergraduate</legend>
                                    <li className='nav-item'>
                                        <Link to='/ug/forms/forceadd' className='nav-links'>New ForceAdd</Link>
                                    </li>
                                    <li className='nav-item'>
                                        <Link to='/ug/forceadd' className='nav-links'>View ForceAdds</Link>
                                    </li>
                                </fieldset>
                                <fieldset>
                                    <legend style={{color: "white"}}>Graduate</legend>
                                    <li className='nav-item'>
                                        <Link to='/grad/forms/forceadd' className='nav-links'>New ForceAdd</Link>
                                    </li>
                                    <li className='nav-item'>
                                        <Link to='/grad/forceadd' className='nav-links'>View ForceAdds</Link>
                                    </li>
                                </fieldset>
                            </ul>
                            }
                        </li>
                    )}
                    {isLoggedIn() && isAdvisor() && ( //Advisor ForceAdd
                        <li
                            className='nav-item'
                            onClick={() => setFADropdown(!faDropdown)}
                            ref={faDropdownRef}
                        >
                            <div className='nav-links'>
                                Force Add <i className='fas fa-caret-down'/>
                            </div>
                            {faDropdown &&
                            <ul className='nav-fa-dropdown-listA desktop-only'>
                                <fieldset>
                                    <legend style={{color: "white"}}>Undergraduate</legend>
                                    <li className='nav-item'>
                                        <Link to='/ug/forms/forceadd' className='nav-links'>New ForceAdd</Link>
                                    </li>
                                    <li className='nav-item'>
                                        <Link to='/ug/forceadd' className='nav-links'>View ForceAdds</Link>
                                    </li>
                                    {isAdmin() && isAdvisor() && (
                                        <li className='nav-item'>
                                            <Link to='/ug/forceaddmin' className='nav-links'>ForceAddmin</Link>
                                        </li>
                                    )}
                                </fieldset>
                                <fieldset>
                                    <legend style={{color: "white"}}>Graduate</legend>
                                    <li className='nav-item'>
                                        <Link to='/grad/forms/forceadd' className='nav-links'>New ForceAdd</Link>
                                    </li>
                                    <li className='nav-item'>
                                        <Link to='/grad/forceadd' className='nav-links'>View ForceAdds</Link>
                                    </li>
                                    {isAdmin() && isAdvisor() && (
                                        <li className='nav-item'>
                                            <Link to='/grad/forceaddmin' className='nav-links'>ForceAddmin</Link>
                                        </li>
                                    )}
                                </fieldset>
                            </ul>
                            }
                        </li>
                    )}
                    {isAdvisor() && ( //P91
                        <li
                            className='nav-item'
                            onClick={() => setP91Dropdown(!p91Dropdown)}
                            ref={p91DropdownRef}
                        >
                            <div className='nav-links'>
                                P91 <i className='fas fa-caret-down'/>
                            </div>
                            {p91Dropdown &&
                                <ul className='nav-p91-dropdown-list desktop-only'>
                                    {/*<li className='nav-item'>
                                        <Link to='/p91' className='nav-links'>Overview</Link>
                                    </li>* /}
                                    <li className='nav-item'>
                                        <Link to='/submissions' className='nav-links'> Submissions </Link>
                                    </li>
                                    <li className='nav-item'>
                                        <Link to='/students' className='nav-links'> Students </Link>
                                    </li>
                                    <li className='nav-item'>
                                        <Link to='/checksheet' className='nav-links'> Checksheet </Link>
                                    </li>
                                </ul>
                            }
                        </li>
                    )}
                    {isAdmin() && ( //Admin
                        <li className='nav-item'>
                            <Link
                                to='/admin'
                                className='nav-links'
                            >
                                Admin
                            </Link>
                        </li>
                    )}
                    <li
                        className='nav-item'
                        onClick={() => setDropdown(!dropdown)}
                        ref={dropdownRef}
                    >
                        <div className='nav-links'>
                            Account <i className='fas fa-caret-down' />
                        </div>
                        {dropdown &&
                            <ul className='nav-dropdown-list desktop-only'>
                                <li className='nav-item'>
                                    <a className='nav-links' href={mobileDisplayedItem.path}>
                                        {mobileDisplayedItem.title}
                                    </a>
                                </li>
                            </ul>
                        }
                    </li>
                </ul>*/}

                <span
                    className={`mobile-dropdown-icon${mobileDropdown ? ' expanded' : ''}`}
                    title='Navigation menu'
                    ref={mobileDropdownRef}
                >
                    <PiListBold
                        onClick={() => setMobileDropdown(!mobileDropdown)}
                    />
                    {mobileDropdown && <ul className='nav-dropdown-list mobile-only'>
                        {(isLoggedIn() && !isFaculty(user)) && (
                            <fieldset>
                                <legend style={{color: "white"}}>Undergraduate ForceAdds</legend>
                                <li className='nav-item'>
                                    <Link to='/ug/forms/forceadd' className='nav-links'>
                                        New ForceAdd
                                    </Link>
                                </li>
                                <li className='nav-item'>
                                    <Link to='/ug/forceadd' className='nav-links'>
                                        View ForceAdds
                                    </Link>
                                </li>
                                {isAdmin() && isAdvisor() && (
                                    <li className='nav-item'>
                                        <Link to='/ug/forceaddmin' className='nav-links'>
                                            ForceAddmin
                                        </Link>
                                    </li>
                                )}
                            </fieldset>
                        )}
                        {(isLoggedIn() && !isFaculty(user)) && (
                            <fieldset>
                                <legend style={{color: "white"}}>Graduate ForceAdds</legend>
                                <li className='nav-item'>
                                    <Link to='/grad/forms/forceadd' className='nav-links'>
                                        New ForceAdd
                                    </Link>
                                </li>
                                <li className='nav-item'>
                                    <Link to='/grad/forceadd' className='nav-links'>
                                        View ForceAdds
                                    </Link>
                                </li>
                                {isAdmin() && isAdvisor() && (
                                    <li className='nav-item'>
                                        <Link to='/grad/forceaddmin' className='nav-links'>
                                            ForceAddmin
                                        </Link>
                                    </li>
                                )}
                            </fieldset>
                        )}
                        {isAdvisor() && (
                            <fieldset>
                                <legend style={{color: "white"}}>P91</legend>
                                {/*<li className='nav-item'>
                                    <Link to='/p91' className='nav-links'>
                                        Overview
                                    </Link>
                                </li>*/}
                                <li className='nav-item'>
                                    <Link to='/submissions' className='nav-links'>
                                        Submissions
                                    </Link>
                                </li>
                                <li className='nav-item'>
                                    <Link to='/students' className='nav-links'>
                                        Students
                                    </Link>
                                </li>
                                <li className='nav-item'>
                                    <Link to='/checksheet' className='nav-links'>
                                        Checksheet
                                    </Link>
                                </li>
                            </fieldset>
                        )}
                        {isLoggedIn() && (isStudent(user) || user?.pid === "bbradner" || (user?.permissions & 8) > 0) && (
                            <fieldset>
                                <legend style={{color: "white"}}>Graduate SAR</legend>
                                {(user?.permissions === 0 || user?.pid === "bbradner") && <>
                                    <li className='nav-item'>
                                        <Link to='/sar/new' className='nav-links'>
                                            New SAR
                                        </Link>
                                    </li>
                                    <li className='nav-item'>
                                        <Link to='/sar/review/' className='nav-links'>
                                            View SAR
                                        </Link>
                                    </li>
                                </>}
                                {/*<li className='nav-item'>
                                    <Link to='/grad/forceadd' className='nav-links'>
                                        View SARs
                                    </Link>
                                </li>*/}
                                {(user?.permissions & 8) > 0 && (
                                    <li className='nav-item'>
                                        <Link to='/sars/admin' className='nav-links'>
                                            SAR Admin
                                        </Link>
                                    </li>
                                )}
                            </fieldset>
                        )}
                        {(user?.permissions & 8) > 0 &&
                            <li className='nav-item'>
                                <Link to='/facultyadmin' className='nav-links'>Faculty Admin</Link>
                            </li>
                        }
                        {isAdmin() && (
                            <li className='nav-item'>
                                <Link to='/admin' className='nav-links'>User Admin</Link>
                            </li>
                        )}
                        <li className='nav-item'>
                            <a className='nav-links' href={mobileDisplayedItem.path}>
                                {mobileDisplayedItem.title}
                            </a>
                        </li>
                    </ul>}
                </span>
            </nav >
        </>
    );
}